<template>
    <div class="conss">
        <div class="pars1 flx alc jsb">
            <div class="paleft">
                <div class="partitle">
                    账户余额(元)
                </div>
                <div class="pabottom flx alc">
                    <div class="paItem">
                        <div class="panum" v-text="n1 * 1"></div>
                        <div class="partitle">
                            收入总额(元):
                        </div>
                    </div>
                    <div class="paItem">
                        <div class="panum" v-text="n2 * 1"></div>
                        <div class="partitle">
                            可提现(元):
                        </div>
                    </div>

                    <div class="paItem">
                        <div class="panum" v-text="n3 * 1"></div>
                        <div class="partitle">
                            待结算(元):
                        </div>
                    </div>

                    <div class="paItem" style="margin-right: 0;">
                        <div class="panum" v-text="n4 * 1"></div>
                        <div class="partitle">
                            已结算(元):
                        </div>
                    </div>
                </div>
            </div>
            <el-button type="primary" @click="showtx = true">去提现</el-button>

        </div>
        <el-tabs v-model="cur" @tab-click="handleClick">
            <el-tab-pane label="收入总额" name="0"></el-tab-pane>
            <el-tab-pane label="提现记录" name="1"></el-tab-pane>
        </el-tabs>
        <div v-if="cur == 0">
            <div class="par1">
                <div class="ips flx alc">
                    <span>时间范围:</span>
                    <el-date-picker v-model="value1" type="datetimerange" :picker-options="pickerOptions"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"
                        format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm">
                    </el-date-picker>
                </div>
            </div>
            <div class="par1 flx jsb">
                <div class="ips flx alc">
                    <span>订单状态:</span>
                    <div class="dstatus">
                        <el-dropdown trigger="click" style="width: 100%;" :hide-on-click="true" @command="userThis">
                            <span style="width: 100%;display: flex;justify-content: space-between;align-items: center;"
                                class="el-dropdown-link">
                                {{statusName}}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu style="width: 200px;" slot="dropdown">
                                <el-dropdown-item command="0" style="width: 160px;">全部</el-dropdown-item>
                                <el-dropdown-item command="1" style="width: 160px;">待结算</el-dropdown-item>
                                <el-dropdown-item command="2" style="width: 160px;">已结算</el-dropdown-item>
                                <el-dropdown-item command="3" style="width: 160px;">提现</el-dropdown-item>
                                <el-dropdown-item command="4" style="width: 160px;">提现驳回</el-dropdown-item>
                                <el-dropdown-item command="5" style="width: 160px;">已退款</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <el-button type="primary" @click="searchResult">搜索</el-button>
            </div>
            <div class="orderTitles flx alc">
                <div class="orderTitle1">
                    订单明细
                </div>
                <div class="orderTitle2">
                    订单费用(元)
                </div>
                <div class="orderTitle3">
                    订单状态
                </div>
            </div>
            <div class="details">
                <div class="ordersContent">
                    <div class="orderItems">
                        <div class="orderItem" v-for="item,index in list">
                            <div class="orderTit flx alc">
                                <div v-text="item.activity_createtime_text" style="margin-right: 24px;"></div>
                                <div v-text="`订单时间:${item.createtime_text}`"></div>
                            </div>
                            <div class="orderContent flx">


                                <div class="orderc1 flx" v-if="item.is_type != 3 && item.is_type != 4">
                                    <div class="orderImage">
                                        <img :src="$img(item.activity_avatar)" alt="" />
                                    </div>
                                    <div class="orderGoodsName" v-text="item.activity_name"></div>
                                    <div class="ordernum">
                                        ×1
                                    </div>
                                </div>

                                <div class="orderc1 flx" v-else style="text-align: center;">
                                    提现记录
                                </div>


                                <div class="orderc2" v-text="`￥${item.money}`">

                                </div>

                                <div class="orderc3" v-text="item.is_type_text">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <el-pagination :current-page="page" :hide-on-single-page="true" :page-size="50"
                    layout="prev, pager, next" @current-change="pagechenage" :total="total">
                </el-pagination>
            </div>
        </div>



        <div v-else>
            <div class="par1">
                <div class="ips flx alc">
                    <span>时间范围:</span>
                    <el-date-picker v-model="value2" type="datetimerange" :picker-options="pickerOptions"
                        range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"
                        format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm">
                    </el-date-picker>
                </div>
            </div>
            <div class="par1 flx jsb">
                <div class="ips flx alc">
                    <span>订单状态:</span>
                    <div class="dstatus">
                        <el-dropdown trigger="click" style="width: 100%;" :hide-on-click="true" @command="usThis">
                            <span style="width: 100%;display: flex;justify-content: space-between;align-items: center;"
                                class="el-dropdown-link">
                                {{tname}}<i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu style="width: 200px;" slot="dropdown">
                                <el-dropdown-item command="100" style="width: 160px;">全部</el-dropdown-item>
                                <el-dropdown-item command="0" style="width: 160px;">申请中</el-dropdown-item>
                                <el-dropdown-item command="1" style="width: 160px;">通过</el-dropdown-item>
                                <el-dropdown-item command="2" style="width: 160px;">驳回</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                </div>
                <el-button type="primary" @click="searchResult1">搜索</el-button>
            </div>
            <div class="orderTitles flx alc">
                <div class="orderTitle2">
                    提现明细
                </div>
                <div class="orderTitle2">
                    提现费用(元)
                </div>
                <div class="orderTitle2">
                    提现状态
                </div>
                <div class="orderTitle2">
                    提现时间
                </div>
            </div>
            <div class="details">
                <div class="ordersContent">
                    <div class="orderItems">
                        <div class="orderItem" v-for="item,index in array">
                            <div class="orderTit flx alc">
                                <div v-text="item.activity_createtime_text" style="margin-right: 24px;"></div>
                                <div v-text="`订单时间:${item.createtime_text}`"></div>
                            </div>
                            <div class="orderContent flx">
                                <div class="orderc2 flx">
                                    账户提现
                                </div>
                                <div class="orderc2" v-text="`${item.money}元`">

                                </div>
                                <div class="orderc2" v-if="item.is_status != 2" v-text="item.is_status_text">

                                </div>
                                <div class="orderc2" v-else>
                                    <div v-text="item.is_status_text"></div>
                                    <div style="color: red;margin-top: 5px;" v-text="item.remark"></div>
                                </div>
                                <div class="orderc2" v-text="item.createtime_text">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <el-pagination :current-page="page1" :hide-on-single-page="true" :page-size="50"
                    layout="prev, pager, next" @current-change="pagechenage1" :total="total1">
                </el-pagination>
            </div>
        </div>

        <div class="txcontent" v-if="showtx">
            <div class="txinner">
                <div class="txTitle flx alc jsb">
                    <span>提现</span>
                    <i class="el-icon-close" @click="showtx = false"></i>
                </div>
                <div class="ip1 flx alc">
                    <div class="ipword">
                        <span style="color:#FF4949;">*</span>
                        提现金额:
                    </div>
                    <div class="ipcontent flx alc jsb">
                        <div class="inmoney flx alc">
                            <div style="margin-right: 15px;">
                                ￥
                            </div>
                            <input placeholder="请输入" v-model="money" type="number">
                        </div>
                    </div>
                </div>

                <div class="ip1 flx alc">
                    <div class="ipword">
                    </div>
                    <div class="ipcontent flx alc jsb">
                        <div class="tips">
                            本次提现金额不能超过 ¥{{n2 * 1}}
                        </div>
                    </div>
                </div>

                <div class="ip1 flx alc mp30">
                    <div class="ipword">
                        <span style="color:#FF4949;">*</span>
                        提现渠道:
                    </div>
                    <div class="ipcontent flx alc jsb">
                        <div class="inmoney flx alc">
                            <div class="xtword">
                                银行卡
                            </div>
                        </div>
                    </div>
                </div>

                <div class="ip1 flx alc mp12">
                    <div class="ipword">
                    </div>
                    <div class="ipcontent flx alc jsb">
                        <div class="tip">
                            充值提现必须使用同一张银行卡(目前仅支持储蓄卡)。为了顺利提现，请正确填写开户支行名称，如有疑问可致电银行客服。
                        </div>
                    </div>
                </div>

                <div class="ip1 flx alc mp30">
                    <div class="ipword">
                        <span style="color:#FF4949;">*</span>
                        收款账户:
                    </div>
                    <div class="ipcontent flx alc jsb">
                        <div class="inmoney flx alc">
                            <input placeholder="请输入收款账户" v-model="account" type="number">
                        </div>
                    </div>
                </div>

                <div class="ip1 flx alc mp30">
                    <div class="ipword">
                        <span style="color:#FF4949;">*</span>
                        收款账户:
                    </div>
                    <div class="ipcontent flx alc jsb">
                        <div class="inmoney flx alc" style="width: 49%;">
                            <input placeholder="请输入开户银行" v-model="bank" type="text">
                        </div>
                        <div class="inmoney flx alc" style="width: 49%;">
                            <input placeholder="请输入开户支行" v-model="bank_branch" type="text">
                        </div>
                    </div>
                </div>

                <div class="ip1 flx alc mp30">
                    <div class="ipword">
                        <span style="color:#FF4949;">*</span>
                        手机验证码:
                    </div>
                    <div class="ipcontent flx alc jsb">
                        <div class="inmoney flx alc" style="flex: 1;">
                            <input placeholder="请输入手机验证码" v-model="yzm" type="text">
                        </div>
                        <div class="sendCode cursor" @click="sendCode">
                            {{ isCountDown ? `${count} 秒后重发` : '获取验证码' }}
                        </div>
                    </div>
                </div>
                <div class="ip1 flx alc">
                    <div class="ipword">
                    </div>
                    <div class="ipcontent flx alc jsb">
                        <div class="tips">
                            验证码将发送到您绑定的手机上：{{hidePhone(tel)}}
                        </div>
                    </div>
                </div>
                <div class="rules flx alc">
                    <div class="squ cursor" @click="hasRead = !hasRead"
                        :style="hasRead?'border:1px solid #007AFF' : ''">
                        <div class="inner" v-if="hasRead"></div>
                    </div>
                    <div class="rule">
                        我已阅读并同意 <b class="cursor" style="color:#007AFF" @click="torules(10)">《提现规则》</b>
                    </div>
                </div>
                <div class="btns flx alc mp30" style="justify-content: flex-end;">
                    <el-button @click="showtx = false">取消</el-button>
                    <el-button type="primary" @click="suntx">确认提现</el-button>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import {
        accountInfo,
        txrecord,
        shoUserInfo,
        applytx,
        sendCode
    } from "@/api/index.js"
    export default {
        name: "asideAc",
        data() {
            return {
                hasRead:false,
                showtx: false,
                isCountDown: false, // 是否正在倒计时
                count: 60, // 倒计时秒数
                timer: null, // 定时器
                codeTxct: "获取验证码",
                code: "",
                sending: false,
                cur: "0",
                list: [],
                array: [],
                page: 1,
                page1: 1,
                statusName: "全部",
                tname: "全部",
                ts: '100',
                status: '0',
                pickerOptions: {
                    shortcuts: [{
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    }, {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }]
                },
                value1: '',
                value2: '',
                total: 0,
                total1: 0,
                n1: 0,
                n2: 0,
                n3: 0,
                n4: 0,
                tel: "",
                money: "",
                account: "",
                bank: "",
                bank_branch: "",
                yzm: ""
            };
        },
        created() {
            let that = this
            that.getRecord()
            shoUserInfo().then((res) => {
                console.log('111111111111', res)
                if (res.code == 1) {
                    that.tel = res.data.tel
                }
            })
        },
        activated() {

        },
        methods: {
            suntx() {
                let that = this
                if(that.hasRead){
                    let data = {}
                    data.money = that.money
                    data.account = that.account
                    data.bank = that.bank
                    data.bank_branch = that.bank_branch
                    data.yzm = that.yzm
                    applytx(data).then((res) => {
                        if (res.code == 1) {
                            that.$message.success(res.msg)
                            that.showtx = false
                            that.getList()
                        } else {
                            that.$message.error(res.msg)
                        }
                    })
                }else{
                    that.$message.warning({
                      message: '请确认已阅读提现规则',
                      zIndex: 99999
                    })
                }
                
            },
            hidePhone(phone) {
                if (!phone) return ''
                // 保留前3位，后4位，中间4位星号
                return phone.slice(0, 3) + '****' + phone.slice(7)
            },
            // 发送验证码
            sendCode() {
                let that = this
                // 简单手机号校验
                if (!/^1[3-9]\d{9}$/.test(this.tel)) {
                  
                    that.$message.warning({
                      message: '请输入正确的手机号',
                      zIndex: 99999
                    })
                    return
                }
                // 模拟发送验证码接口
                console.log('发送验证码到：', this.tel)
                if (this.isCountDown == false) {
                    let data = {}
                    data.tel = that.tel
                    data.type = 2
                    sendCode(data).then((res) => {
                        console.log(res)
                        if (res.code == 1) {
                            // 开始倒计时
                            this.isCountDown = true
                            let time = this.count
                            this.timer = setInterval(() => {
                                time--
                                this.count = time
                                if (time <= 0) {
                                    clearInterval(this.timer)
                                    this.isCountDown = false
                                    this.count = 60
                                }
                            }, 1000)
                            that.$message.success({
                              message: '验证码已发送',
                              zIndex: 99999
                            })
                        } else {
                            that.$message.error(res.msg)
                        }
                    })

                }
            },
            usThis(e) {
                this.ts = e
                if (e == 100) {
                    this.tname = '全部'
                } else if (e == 0) {
                    this.tname = '申请中'
                } else if (e == 1) {
                    this.tname = '通过'
                } else if (e == 2) {
                    this.tname = '驳回'
                }

            },
            pagechenage1() {
                let that = this
                that.page1 = 1
                that.array = []
                that.getList()
            },
            handleClick(e) {
                let that = this
                console.log("e=", e)
                if (e.index == '0') {
                    that.page = 1
                    that.value1 = ''
                    that.list = []
                    that.getRecord()
                } else {
                    that.page = 1
                    that.value2 = ''
                    that.array = []
                    that.getList()
                }
            },
            getList() {
                let that = this
                let data = {}
                data.page = that.page1
                data.size = 50
                data.is_status = that.ts
                data.begin_time = that.value2[0] || ''
                data.over_time = that.value2[1] || ''
                txrecord(data).then((res) => {
                    if (res.code == 1) {
                        that.array = res.data.data
                        that.total = res.data.total
                    }
                })
            },
            searchResult() {
                let that = this
                that.page = 1
                that.list = []
                that.getRecord()
            },
            searchResult1() {
                let that = this
                that.page1 = 1
                that.array = []
                that.getList()
            },
            pagechenage(e) {
                this.page = e
                this.list = []
                this.getRecord()
            },
            getRecord() {
                let that = this
                let data = {}
                data.page = that.page
                data.size = 50
                data.is_type = that.status
                data.begin_time = that.value1[0] || ''
                data.over_time = that.value1[1] || ''
                accountInfo(data).then((res) => {
                    console.log(res)
                    if (res.code == 1) {
                        that.total = res.data.list.total
                        that.list = res.data.list.data
                        that.n1 = res.data.total_money
                        that.n2 = res.data.tx_total_money2
                        that.n3 = res.data.daijiesuan_total_money * 1
                        that.n4 = res.data.yijiesuan_total_money
                    }
                })
            },
            torules(e) {
                window.open('https://two.hrxsl.com/rules?type=' + e + '&t=' + Date.now(), '_blank');
            },
            userThis(e) {
                console.log(e)
                if (e == 0) {
                    this.statusName = '全部'
                } else if (e == 1) {
                    this.statusName = '待结算'
                } else if (e == 2) {
                    this.statusName = '已结算'
                } else if (e == 3) {
                    this.statusName = '提现'
                } else if (e == 4) {
                    this.statusName = '提现驳回'
                } else if (e == 5) {
                    this.statusName = '已退款'
                }
                this.page = 1
                this.lsit = []
                this.status = e
                // this.getRecord()
            }
        }
    };
</script>

<style scoped>
    .rules {
        margin-top: 24px;
        box-sizing: border-box;
        padding-left: 120px;
    }
    
    .inner {
        width: 100%;
        height: 100%;
        background: #007AFF;
    }
    
    .el-message {
      z-index: 999999 !important;
    }
    
    .rule {
        font-weight: 500;
        font-size: 12px;
        color: #333333;
    }
    
    .squ {
        width: 14px;
        height: 14px;
        border-radius: 1px;
        border: 1px solid #D9D9D9;
        margin-right: 8px;
        box-sizing: border-box;
        padding: 2px;
    }
    
    .shne {
        height: 46px;
        border-radius: 6px 6px 6px 6px;
        border: 1px solid #D9D9D9;
        font-weight: 500;
        font-size: 14px;
        color: #141933;
        line-height: 46px;
        box-sizing: border-box;
        padding: 0 20px;
    
    }
    .sendCode {
        width: 110px;
        height: 46px;
        border-radius: 6px;
        font-size: 14px;
        color: #141933;
        border: 1px solid #D9D9D9;
        margin-left: 10px;
        background: #fff !important;
    }

    .mp12 {
        margin-top: 12px;
    }

    .tip {
        font-weight: 500;
        font-size: 12px;
        color: #999999;
    }

    .mp30 {
        margin-top: 30px;
    }

    .xtword {
        font-weight: 500;
        font-size: 14px;
        color: #141933;
    }

    .tips {
        width: 100%;
        height: 40px;
        background: #F8F9FA;
        font-size: 14px;
        color: #999999;
        line-height: 40px;
        box-sizing: border-box;
        padding: 0 20px;
        margin-top: 10px;
    }

    .inmoney input {
        width: 100%;
        height: 100%;
        border: none !important;
        outline: none !important;
        font-size: 14px;
    }

    .inmoney {
        box-sizing: border-box;
        padding: 13px 20px;
    }

    .ipword {
        width: 92px;
        margin-right: 20px;
        font-size: 14px;
        color: #48576A;
        text-align: right;
    }

    .ip1 {
        width: 100%;
    }

    .inmoney {
        width: 100%;
        height: 46px;
        border-radius: 6px;
        border: 1px solid #D9D9D9;
        color: #666;
    }

    .txTitle {
        width: 100%;
        margin-bottom: 30px;
    }

    .ipcontent {
        flex: 1
    }

    .txTitle span {
        font-weight: 600;
        font-size: 20px;
        color: #333333;
    }

    .el-icon-close {
        font-size: 20px;
        font-weight: bolder;
        color: #000;
    }

    .txinner {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        width: 628px;
        height: 726px;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 30px;
    }

    .txcontent {
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, .5);
        z-index: 98745 !important;
    }

    .dstatus {
        width: 223px;
        height: 46px;
        border-radius: 6px 6px 6px 6px;
        border: 1px solid #D9D9D9;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 20px;
    }

    .inners {
        width: 100%;
        box-sizing: border-box;
        padding: 20px;
    }

    .par1 {
        margin-bottom: 24px;
    }

    .ips span {
        font-size: 14px;
        color: #48576A;
        margin-right: 20px;
    }

    .btstyle2 {
        font-size: 12px;
        color: #666666;
        line-height: 21px;
        margin-top: 6px;
        cursor: pointer;
    }

    .btstyle1 {
        width: 74px;
        height: 24px;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #E4393C;
        color: #E4393C;
        text-align: center;
        line-height: 24px;
        font-size: 12px;
        cursor: pointer;
    }

    .topor {
        text-align: center;
        padding: 6px 0;
        border-bottom: 1px solid #D9D9D9;
        font-weight: 600;
        font-size: 14px;
        color: #333333;
    }

    .botor {
        text-align: center;
        padding: 8px 0;
        font-size: 12px;
        color: #999999;
        line-height: 21px;
    }

    .ordernum {
        font-size: 14px;
        color: #999999;
        flex: 1;
        text-align: right;
    }

    .orderGoodsName {
        font-weight: 600;
        font-size: 14px;
        color: #666666;
        width: 240px;
        text-align: left;
    }

    .orderImage {
        width: 80px;
        height: 80px;
        margin-right: 10px;
    }

    .orderImage img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
    }

    .orderContent {
        background: #fff;
    }

    .orderItems {
        margin-top: 21px;
        height: 780px;
        overflow-y: auto;
    }

    .orderTit {
        height: 32px;
        background: #F2F2F2;
        width: 100%;
        box-sizing: border-box;
        padding: 0 20px;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
    }

    .orderItem {
        width: 99.8%;
        border: 1px solid #D9D9D9;
        margin-bottom: 20px;
    }

    .ordersContent {
        box-sizing: border-box;
    }

    .orderTitles {
        height: 32px;
        background: #F2F2F2;
        width: 100%;

    }

    .orderc1 {
        width: 464px;
        height: 128px;
        box-sizing: border-box;
        padding: 24px;
        border-right: 1px solid #D9D9D9;
    }

    .orderc2 {
        flex: 1;
        height: 128px;
        border-right: 1px solid #D9D9D9;
        display: flex;
        flex-direction: column;
        justify-content: center;
        box-sizing: border-box;
        padding: 20px;
        text-align: center;
    }

    .orderc3 {
        flex: 1;
        height: 128px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        box-sizing: border-box;
        padding: 20px;
        text-align: center;
    }

    .orderc4 {
        width: 176px;
        height: 128px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .orderTitle1 {
        width: 464px;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
    }

    .orderTitle2 {
        flex: 1;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
    }

    .orderTitle3 {
        flex: 1;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
    }

    .orderTitle4 {
        width: 176px;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #666666;
    }

    .paItem {
        margin-right: 93px;
        flex-shrink: 0;
    }

    .panum {
        font-weight: 600;
        font-size: 32px;
        color: #333333;
        line-height: 45px;
        padding: 12px 0;
        text-align: left;
    }

    .partitle {
        font-size: 13px;
        color: #333333;
    }

    .pars1 {
        width: 100%;
        background: #f8f8f8;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 30px;
    }

    .conss {
        box-sizing: border-box;
        padding: 20px;
        text-align: left;
    }
</style>